import ErrorSection from './ErrorSection';

export default ErrorSection;
